import gsap from "gsap";
import { MotionPathPlugin } from "gsap/all";

gsap.registerPlugin(MotionPathPlugin);

import Experience from "../Experience";
import Vehicle from "./Vehicle";

export default class Vehicles {
  constructor () {
    this.experience = new Experience();
    this.resources = this.experience.resources.items
    this.container = document.querySelector(".vehicles");

    this.animations = {
      hybrid: {},
      growth: {}
    };

    this.hybrid = {
      airplane: new Vehicle({
        sprite: this.resources.airplaneTurn,
        shadow: this.resources.airplaneTurnShadow,
        position: "35.15,65",
        label: "KLM 1256",
        color: "color-1",
        type: "hybrid",
        rotationStep: 20
      })
    }

    this.growth = {
      airplane: new Vehicle({
        sprite: this.resources.airplaneTurn,
        shadow: this.resources.airplaneTurnShadow,
        position: "60.15,24",
        label: "BAW 342",
        color: "color-1",
        rotationStep: 20
      }),
      car: new Vehicle({
        sprite: this.resources.carTurn,
        shadow: this.resources.carTurnShadow,
        position: "65,31",
        label: "FIRE 2",
        color: "color-2",
        type: "growth",
      }),
      fuelEngine: new Vehicle({
        sprite: this.resources.fuelEngineTurn,
        shadow: this.resources.fuelEngineTurnShadow,
        position: "33,31",
        label: "TANKER 1",
        color: "color-2",
        rotationStep: 6
      }),
      tow: new Vehicle({
        sprite: this.resources.towTurn,
        shadow: this.resources.towTurnShadow,
        position: "53.5,49",
        label: "TOW 1",
        color: "color-2",
        rotationStep: 6
      }),
    }

    this.container.appendChild(this.growth.car.element);
    this.container.appendChild(this.growth.fuelEngine.element);
    this.container.appendChild(this.growth.tow.element);
    this.container.appendChild(this.growth.airplane.element);
    this.container.appendChild(this.hybrid.airplane.element);

    this.setAnimations();
  }

  setAnimations () {
    this.animations.hybrid.airplane = this.hybridAirplaneLoop();
    this.animations.growth.tow = this.growthTowLoop();
    this.animations.growth.airplane = this.growthAirplaneLoop();
  }

  growthAirplaneLoop () {
    const tl = gsap.timeline({
      repeat: -1,
      repeatDelay: 17,
      paused: true
    });
    const target = this.growth.airplane;
    const ease = "power1.inOut";

    // Taxi and takeoff
    tl
    .add(target.rotate(20, 0))
    .to(target.element, { xPercent: -1, yPercent: 40, duration: 4, ease })
    .add(target.rotate(24), ">-=0.25")
    .to(target.element,
      {
        duration: 20,
        ease,
        motionPath: {
          curviness: 0.5,
          path: [
            {
              xPercent: -125,
              yPercent: -25
            },
            {
              xPercent: -180,
              yPercent: -5
            },
            {
              xPercent: -500,
              yPercent: -190
            },
            {
              xPercent: -565,
              yPercent: -160
            },
          ]
        }
      }
    )
    .add(target.rotate(0, 0), 10.8)
    .add(target.rotate(5, 0.25), ">")
    .add(target.rotate(0, 0.25), 12)
    .add(target.rotate(24, 0), ">")
    .add(target.rotate(0, 0), 19.3)
    .add(target.rotate(5), ">")
    .add(target.rotate(11), 23.5)
    .to(target.element, { xPercent: 1300, yPercent: 1000, duration: 6, ease: "power4.in" }, "+=5")
    .to(target.sprite, { scale: 4, xPercent: 400, yPercent: -300, duration: 3, ease: "power4.in" }, ">-=3")
    .to(target.shadow, { scale: 0.25, duration: 3, ease: "power4.in" }, ">-=3")
    .to(target.element, { autoAlpha: 0, ease: "none" }, ">-=0.5")
    .to({}, { duration: 5})

    // Landing and taxi
    tl
    .add(target.rotate(11, 0), "landing-start")
    .set(target.element, { autoAlpha: 1, xPercent: -2000, yPercent: -1000 }, "landing-start")
    .set(target.sprite, { scale: 4, xPercent: -200, yPercent: -800 }, "landing-start")
    .to(target.element, { xPercent: -565, yPercent: -160, duration: 3, ease: "none" })
    .to(target.sprite, { scale: 1, xPercent: 0, yPercent: 0, duration: 3, ease: "power1.out" }, ">-=3")
    .to(target.shadow, { scale: 1, duration: 3, ease: "power1.out"}, ">-=3")
    .to(target.element, { xPercent: 0, yPercent: 170, duration: 5, ease: "power4.out"})
    .to(target.element,
      {
        duration: 16,
        ease,
        motionPath: {
          curviness: 0.25,
          path: [
            {
              xPercent: 125,
              yPercent: 235
            },
            {
              xPercent: 145,
              yPercent: 175
            },
            {
              xPercent: -25,
              yPercent: 90
            },
            {
              xPercent: 0,
              yPercent: 0
            },
          ]
        }
      }
    )
   .add(target.rotate(19), 54)
   .add(target.rotate(24), 55.4)
   .add(target.rotate(20), 59.1)

    return tl;
  }

  growthTowLoop () {
    const tl = gsap.timeline({
      paused: true,
      repeat: -1,
      repeatDelay: 13
    });
    const target = this.growth.tow;
    const ease = "power1.inOut";

    tl
    .to(target.element,
      {
        duration: 1,
        ease,
        motionPath: {
          path: [
            {
              xPercent: -20,
              yPercent: 10,
            },
            {
              xPercent: 0,
              yPercent: 40
            }
          ]
        }
      }
    )
    .add(target.rotate(12), "<+=0.25")
    .to(target.element,
      {
        duration: 6,
        ease,
        motionPath: {
          path: [
            {
              xPercent: -40,
              yPercent: 20,
            },
            {
              xPercent: -100,
              yPercent: 100
            },
            {
              xPercent: -260,
              yPercent: 200
            },
            {
              xPercent: -270,
              yPercent: 280
            },
          ]
        }
      }
    )
    .add(target.rotate(20, 1), 1.9)
    .add(target.rotate(18), 3.3)
    .add(target.rotate(21, 1), 4.6)

    // return
    .to(target.element,
      {
        duration: 2,
        ease,
        motionPath: {
          path: [
            {
              xPercent: -270,
              yPercent: 200
            },
            {
              xPercent: -300,
              yPercent: 170
            }
          ]
        }
      },
      "+=10"
    )
    .add(target.rotate(24), ">-=1.1")
    .add(target.rotate(0, 0), ">")
    .to(target.element,
      {
        duration: 6,
        ease,
        motionPath: {
          path: [
            {
              xPercent: -200,
              yPercent: 200
            },
            {
              xPercent: -100,
              yPercent: 50
            },
            {
              xPercent: 0,
              yPercent: 0
            }
          ]
        }
      }
    )
    .add(target.rotate(8, 1.3), 20.3)
    .add(target.rotate(6), 22.4)

    return tl;
  }

  hybridAirplaneLoop () {
    const tl = gsap.timeline({
      repeat: -1,
      repeatDelay: 23
    });
    const target = this.hybrid.airplane;
    const ease = "power1.inOut";

    // Taxi and takeoff
    tl
    .add(target.rotate(20, 0))
    .to(target.element, { xPercent: -1, yPercent: 90, duration: 4, ease })
    .add(target.rotate(24), ">-=0.25")
    .to(
      target.element,
      {
        duration: 20,
        ease: "power1.inOut",
        motionPath: {
          curviness: 0.5,
          path: [
            {
              xPercent: -260,
              yPercent: -20
            },
            {
              xPercent: -300,
              yPercent: 0
            },
            {
              xPercent: -575,
              yPercent: -150
            },
            {
              xPercent: -650,
              yPercent: -115
            },
            {
              xPercent: -600,
              yPercent: -90
            },
          ]
        }
      },
      ">-=0.5"
    )
    .add(target.rotate(0, 0), 11.7)
    .add(target.rotate(5, 1), ">")
    .add(target.rotate(0), 12.7)
    .add(target.rotate(24, 0), ">")
    .add(target.rotate(0, 0), 17.6)
    .add(target.rotate(5), ">")
    .add(target.rotate(11), 19.7)
    .to(target.element, { xPercent: 1300, yPercent: 1000, duration: 6, ease: "power4.in" }, "+=5")
    .to(target.sprite, { scale: 4, xPercent: 400, yPercent: -300, duration: 3, ease: "power4.in" }, ">-=3")
    .to(target.shadow, { scale: 0.25, duration: 3, ease: "power4.in" }, ">-=3")
    .to(target.element, { autoAlpha: 0, ease: "none" }, ">-=0.5")
    .to({}, { duration: 1})

      // Landing and taxi
    tl
    .add(target.rotate(11, 0), "landing-start")
    .set(target.element, { autoAlpha: 1, xPercent: -2000, yPercent: -1000 }, "landing-start")
    .set(target.sprite, { scale: 4, xPercent: -200, yPercent: -800 }, "landing-start")
    .to(target.element, { xPercent: -500, yPercent: -50, duration: 3, ease: "none" })
    .to(target.sprite, { scale: 1, xPercent: 0, yPercent: 0, duration: 3, ease: "power1.out" }, ">-=3")
    .to(target.shadow, { scale: 1, duration: 3, ease: "power1.out"}, ">-=3")
    .to(target.element, { xPercent: 0, yPercent: 250, duration: 5, ease: "power4.out"})
    .to(target.element, {
      duration: 16,
      ease,
      motionPath: {
        curviness: 0.2,
        path: [
          {
            xPercent: 100,
            yPercent: 300, 
          },
          {
            xPercent: 110,
            yPercent: 250, 
          },
          {
            xPercent: -50,
            yPercent: 150, 
          },
          {
            xPercent: 0,
            yPercent: 140, 
          },
          {
            xPercent: 0,
            yPercent: 0, 
          },
        ]
      }
    })
    .add(target.rotate(19), 48.6)
    .add(target.rotate(24), 49.7)
    .add(target.rotate(16), 52.8)
    .add(target.rotate(20), 53.8)

    return tl;
  }
}